
import vue from "vue";
import Toast from 'vux/src/components/toast/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Radio from 'vux/src/components/radio/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Selector from 'vux/src/components/selector/index.vue'

import { initWxJSSDK, installTerminal } from "../../common/js/api.js";
import { getCookie, setCookie, removeCookie } from "../../common/js/utils.js";
import { TMap } from "../../common/js/map.js";

export default {
directives: {
TransferDom
},
components: {
Toast,
Picker,
PopupPicker,
XHeader,
Box,
XButton,
XInput,
Group,
CellBox,
Cell,
Scroller,
Icon,
Search,
Flexbox,
FlexboxItem,
TransferDom,
Radio,
Popup,
Grid,
GridItem,
GroupTitle,
Selector
},
methods: {
onShow() {
console.log("on show");
},
onHide(type) {
console.log("on hide", type);
},
inputTypeChange(v) {

if (v[0] == "扫码") {
this.view.inputTypeFlag = 1;
} else {
this.view.inputTypeFlag = 2;
}
},
scanQRCode() {
let self = this;



this.$wechat.scanQRCode({
needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
success: function(res) {



var result = res.resultStr; 
if (result.split(",").length > 1) {
result = result.split(",")[1];
}





if (result.indexOf("IMEI") === -1) {
self.entity.terminalId = "869696043720346";
self.$vux.toast.text("二维码错误");
return true;
}
result = result.substr(result.indexOf("IMEI") + 5);
result = result.split(";")[0];
self.entity.terminalId = result;
self.$forceUpdate();

}
});
},
initLocation() {
let self = this;
self.$wechat.getLocation({
type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
fail: function(res) {
console.error(res);
},
success: function(res) {
var latitude = res.latitude; 
var longitude = res.longitude; 
var speed = res.speed; 
var accuracy = res.accuracy; 
if ((latitude + "").length > 13) {
latitude = parseFloat(latitude).toFixed(10);
}
if ((longitude + "").length > 13) {
longitude = parseFloat(longitude).toFixed(10);
}
self.latLng = longitude + "," + latitude;
self.entity.longitude = longitude;
self.entity.latitude = latitude;

self.center = new qq.maps.LatLng(latitude, longitude);
self.setCenter(self.center);



}
});
},
setCenter(_center) {
this.map.panTo(_center);
},
saveTerminal() {
let self = this;





if (!self.entity.terminalId) {
self.$vux.toast.text("请输入设备编号");
return;
}
installTerminal({ data: this.entity }).then(function(data) {
self.$vux.toast.text("安装保存成功");
history.go(-1);
});
}
},
data() {
return {
center: {},
map: {},
dataSource: [],
terminals: [],
currentTerminal: { extInfo: {} },
isPopup: true,
listShow: true,
serialNumber: 0,
times: 0,
list: [],
latLng: null,
entity: { boxType: 2, terminalType: 1 },
value1: ["扫码"],
view: {
inputTypeFlag: 1,
inputType: "扫码",
inputTypes: [["扫码", "手工录入"]]
},
sid: null
};
},
created() {},
mounted() {
let self = this;
let orderId = this.$route.query.orderId;
self.sid = this.$route.query.sid;
self.entity.orderId = orderId;
self.entity.sid = self.sid;
initWxJSSDK();
var longitude = getCookie("longitude");
var latitude = getCookie("latitude");
if (!latitude) {
latitude = 39.916527;
}
if (!longitude) {
longitude = 116.397128;
}
TMap("").then(qq => {
self.map = new qq.maps.Map(document.getElementById("map-container"), {

center: new qq.maps.LatLng(latitude, longitude),
zoom: 18,
disableDefaultUI: true
});
qq.maps.event.addListener(self.map, "center_changed", function() {

var latitude = self.map.getCenter().lat; 
var longitude = self.map.getCenter().lng; 
if ((latitude + "").length > 13) {
latitude = parseFloat(latitude).toFixed(10);
}
if ((longitude + "").length > 13) {
longitude = parseFloat(longitude).toFixed(10);
}
self.latLng = longitude + "," + latitude;
self.entity.longitude = longitude;
self.entity.latitude = latitude;
});

});
vue.wechat.ready(function(res) {
self.initLocation();
});
}
};



// WEBPACK FOOTER //
// ./src/components/support/Install.vue